// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"121":"gallery","443":"about","511":"cart","566":"catering","637":"order"}[chunkId] || chunkId) + "." + {"121":"a72732be","443":"12485c0e","511":"cbe5d125","566":"0f259bc3","637":"d418f75d","720":"625d859f"}[chunkId] + ".js";
};